import styled, { keyframes } from "styled-components";

const glow = keyframes`
from {
    text-shadow: 0 0 10px #ffd400, 0 0 20px #ffd400, 0 0 30px #ffd400
      0 0 40px #ffd400 0 0 50px #ffd400 0 0 60px #ffd400 0 0 70px #ffd400;
  }
  to {
    text-shadow: 0 0 20px #ffd400, 0 0 30px #ffd400, 0 0 40px #ffd400,
      0 0 50px #ffd400, 0 0 60px #ffd400, 0 0 70px #ffd400, 0 0 80px #ffd400;
  }
`;

export const Header = styled.h3`
  font-size: 22px;
  color: black;
  //   text-align: center;
  -webkit-animation: ${glow} 1s ease-in-out infinite alternate;
  -moz-animation: ${glow} 1s ease-in-out infinite alternate;
  animation: ${glow} 1s ease-in-out infinite alternate;
`;
